<template>
    <header>
        <div class="top-header-nav">
            <span class="hcps">For US Healthcare Professionals</span>
            <div class="links">
                <a href="https://www.jornaypm.com/" target="_blank">Visit Patient Site</a>
                <a href="javascript:void(0);" @click="showWidget">Important Safety Information</a>
                <a href="https://www.collegiumpharma.com/wp-content/uploads/JORNAY_PM_Label.pdf" class=""
                    target="_blank">Full Prescribing Information</a>
                <!-- <a href="/Price_Disclosure" class="hide">Pricing Information</a> -->
                <!-- <a style="color: #30368c" href="/peerspectives" class="hide">ADHD PeerSpectives</a> -->
            </div>
        </div>
        <div class="header-wrpr">
            <div id="desktopmenunav" class="desktop-menu" :class="{ 'is-sticky': isStiky }">
                <div class="logo">
                    <a href="/"><img alt="JORNAY PM (methylphenidate HCI) logo"
                            src="@/assets/img/header/jornay-logo.svg" /></a>
                </div>
                <div class="meu">
                    <ul class="main-menu">
                        <li class="has-submenu">
                            <a href="javascript:void(0);" data-link-active="about" class="jornay-option">
                                <div>
                                    <span>Why JORNAY PM</span>
                                    <img alt="" src="@/assets/img/new-home/menu-arrow.png" />
                                </div>
                            </a>
                            <ul class="sub-menu">
                                <li :class="{
                                    'active-submenu':
                                        currentPath ===
                                        '/adhd-medication-efficacy',
                                }">
                                    <a href="/adhd-medication-efficacy">Efficacy</a>
                                </li>
                                <li :class="{
                                    'active-submenu':
                                        currentPath ===
                                        '/methylphenidate-dosage-duration',
                                }">
                                    <a href="/methylphenidate-dosage-duration">PK/PD Model</a>
                                </li>
                                <li :class="{
                                    'active-submenu':
                                        currentPath === '/pk-data',
                                }">
                                    <a href="/pk-data">PK Profile</a>
                                </li>
                            </ul>
                        </li>
                        <hr class="divider" />
                        <li>
                            <a href="/dosing" data-link-active="dosing">Dosing</a>
                        </li>
                        <hr class="divider" />
                        <li>
                            <a href="/safety" data-link-active="safety">Safety</a>
                        </li>
                        <hr class="divider" />
                        <li class="has-submenu">
                            <a href="javascript:void(0);" data-link-active="savings">
                                <span>Savings & Resources</span>
                                <img alt="" src="@/assets/img/new-home/menu-arrow.png" />
                            </a>
                            <ul class="sub-menu">
                                <li :class="{
                                    'active-submenu':
                                        currentPath === '/savings',
                                }">
                                    <a href="/savings">Patient Savings</a>
                                </li>
                                <li :class="{
                                    'active-submenu':
                                        currentPath === '/resources',
                                }">
                                    <a href="/resources">Downloadable Resources</a>
                                </li>
                                <!-- <li :class="{
                                    'active-submenu':
                                        currentPath === '/peerspectives',
                                }">
                                    <a href="/peerspectives">ADHD PeerSpectives</a>
                                </li> -->
                            </ul>
                        </li>
                        <hr class="divider" />
                        <li>
                            <a href="/sign-up" data-link-active="sign-up">Sign Up</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="header-mobile-wrpr">
            <div class="mobile-menu" :class="{ 'is-sticky': isStiky }">
                <div class="top">
                    <div class="logo">
                        <a href="/"><img class="img-fluid" alt="JORNAY PM (methylphenidate HCI) logo"
                                src="@/assets/img/header/jornay-logo.svg" /></a>
                    </div>
                    <div id="mm" @click="openMobileMenu">
                        <div id="nav-icon1">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <div id="nav-txt">MENU</div>
                    </div>
                    <div id="backdrop"></div>
                </div>
                <div id="mobile-list-menu">
                    <ul class="main-menu" id="mainMenu" style="
                                height: calc(100vh - 14rem);
                                overflow: scroll;
                                scroll-snap-type: none;
                                
                            ">
                        <div >
                            <li @click="openSubmenu($event)" class="has-submenu">
                                <a href="javascript:void(0);">Why JORNAY PM</a>
                                <ul class="sub-menu">
                                    <li :class="{
                                        'active-submenu':
                                            currentPath ===
                                            '/adhd-medication-efficacy',
                                    }">
                                        <a href="/adhd-medication-efficacy">Efficacy</a>
                                    </li>
                                    <li :class="{
                                        'active-submenu':
                                            currentPath ===
                                            '/methylphenidate-dosage-duration',
                                    }">
                                        <a href="/methylphenidate-dosage-duration">PK/PD Model</a>
                                    </li>
                                    <li :class="{
                                        'active-submenu':
                                            currentPath === '/pk-data',
                                    }">
                                        <a href="/pk-data">PK Profile</a>
                                    </li>
                                </ul>
                            </li>
                            <li :class="{
                                'active-submenu': currentPath === '/dosing',
                            }">
                                <a href="/dosing">Dosing</a>
                            </li>
                            <li :class="{
                                'active-submenu': currentPath === '/safety',
                            }">
                                <a href="/safety">Safety</a>
                            </li>
                            <li @click="openSubmenu($event)" class="has-submenu">
                                <a href="javascript:void(0);">Savings & Resources</a>
                                <ul class="sub-menu">
                                    <li :class="{
                                        'active-submenu':
                                            currentPath === '/savings',
                                    }">
                                        <a href="/savings">Patient Savings</a>
                                    </li>
                                    <!-- <li><a href="/#find-jornaypm">Find JORNAY PM</a></li> -->
                                    <li :class="{
                                        'active-submenu':
                                            currentPath === '/resources',
                                    }">
                                        <a href="/resources">Downloadable Resources</a>
                                    </li>
                                    <!-- <li :class="{
                                        'active-submenu':
                                            currentPath ===
                                            '/peerspectives',
                                    }">
                                        <a href="peerspectives">ADHD PeerSpectives</a>
                                    </li> -->
                                </ul>
                            </li>
                            <li :class="{
                                'active-submenu':
                                    currentPath === '/sign-up',
                            }">
                                <a class="border-0" href="/sign-up">Sign Up</a>
                            </li>
                            <li @click="
                                goMenuToUrl(
                                    'https://www.jornaypm.com/',
                                    true
                                )
                                " class="gray">
                                <a href="javascript:void(0);" class="gray">Visit Patient Site</a>
                            </li>
                            <li @click="showWidget" class="gray">
                                <a href="javascript:void(0);">Important Safety Information</a>
                            </li>
                            <li @click="
                                goMenuToUrl(
                                    'https://www.collegiumpharma.com/wp-content/uploads/JORNAY_PM_Label.pdf',
                                    true
                                )
                                " class="gray">
                                <a href="javascript:void(0);">Full Prescribing Information</a>
                            </li>

                        </div>
                    </ul>
                </div>
            </div>
        </div>

        <div class="blue-line-top"></div>
    </header>
</template>

<script>
import _ from 'lodash';
export default {
    data() {
        return {
            isStiky: false,
            scrollPos: 0,
        };
    },
    mounted() {
        let scrollPos = 0;
        this.scrollHandler = _.debounce(this.onScroll, 20);
        window.addEventListener('scroll', this.scrollHandler);
        let alertBanner = document.getElementsByClassName('alert-banner');

        let isAccepted =
            localStorage.getItem('journayhcpmodalacepted') === 'true' ||
            sessionStorage.getItem('shortage_v') === 'true' ||
            false;

        if (isAccepted) {
            setTimeout(function () {
                alertBanner[0].classList.add('show');
            }, 1000);
        }

        this.$root.$on('modal', (data) => {
            if (data == 'accept') {
                setTimeout(function () {
                    alertBanner[0].classList.add('show');
                }, 1000);
            }
        });

        let element = document.getElementById("mainMenu");
        if (element) {
            element.style.height = "calc(100vh - 14rem)";
        }
    },

    methods: {
        showWidget() {
            var menu = document.getElementById('mobile-list-menu');
            this.$root.$emit('show-widget', 'click');
            if (menu.classList.contains('open')) {
                this.openMobileMenu();
            }
        },
        
        onScroll() {
            let scrollPos = document.body.getBoundingClientRect().top;
            if (scrollPos != this.scrollPos) {
                if (
                    document.body.getBoundingClientRect().top > this.scrollPos
                ) {
                    this.isStiky = true;
                } else {
                    this.isStiky = false;
                }

                if (window.pageYOffset < 100) {
                    this.isStiky = false;
                }
            }
            this.scrollPos = scrollPos;
        },
        scrollMeTo(refName) {
            var element = document.getElementById(refName);
            if (element) {
                location.href = '/#' + refName;
            } else {
                location.href = '/#' + refName;
            }

            this.openMobileMenu();
        },
        openMobileMenu() {
            var hamburguer = document.getElementById('mm');
            var menu = document.getElementById('mobile-list-menu');
            var backdrop = document.getElementById('backdrop');

            if (menu.classList.contains('open')) {
                hamburguer.classList.remove('open');
                menu.classList.remove('open');
                backdrop.classList.remove('open');
                document.body.classList.remove('menu-open'); // Re-enable page scroll
            } else {
                hamburguer.classList.add('open');
                menu.classList.add('open');
                backdrop.classList.add('open');
                document.body.classList.add('menu-open'); // Disable page scroll
            }
        },
        openSubmenu(e) {
            let submenu;
            let theTop;
            if (e.target.tagName.toLowerCase() === 'a') {
                theTop = e.target.closest('.has-submenu');
                submenu = theTop.querySelector('.sub-menu');

            } else {
                theTop = e.target.closest('.has-submenu');
                submenu = theTop.querySelector('.sub-menu');
            }

            if (submenu.classList.contains('open')) {
                submenu.classList.remove('open');
                theTop.classList.remove('open');
            } else {
                submenu.classList.add('open');
                theTop.classList.add('open');
            }
        },
        goMenuToUrl(url, blank) {
            if (blank === true) {
                window.open(url, '_blank').focus();
            } else {
                location.href = url;
            }
        },
    },
    computed: {
        currentPath() {
            return window.location.pathname;
        },
    },
};
</script>
